import { useMemo } from 'react';
import { UserRankingDto } from '@repo/shared/dtos/analytics/UtilizationDto';

export function useMemberSearch(data: UserRankingDto[], searchTerm: string) {
  return useMemo(() => {
    if (!searchTerm.trim()) return data;
    const term = searchTerm.toLowerCase();
    return data.filter(
      user =>
        user.first_name.toLowerCase().includes(term) ||
        user.last_name.toLowerCase().includes(term) ||
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(term),
    );
  }, [data, searchTerm]);
}
